function triggerEdapEvent(eventName = '', eventData = {}, options = {}) {
    if (typeof window !== 'undefined') {
        window.edap.push((edapInstance) => {
            edapInstance.trigger(eventName, eventData, options);
        });
    }
}

function triggerEdapPageView() {
    if (typeof window !== 'undefined') {
        window.analyticsdatalayer.pagename = window.location.pathname;

        window.edap.push((edapInstance) => {
            edapInstance.trigger('pageview');
        });
    }
}

export {triggerEdapEvent, triggerEdapPageView};
